import React, { Fragment, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cx } from '../utils';
import './PageHeader.css';

// breadcrumb: [{ label, to? }] massivi (oxirgi element — joriy sahifa) yoki tayyor ReactNode.
function renderBreadcrumb(breadcrumb) {
  if (!Array.isArray(breadcrumb)) return breadcrumb;
  return (
    <ol className="ui-page-header__crumbs">
      {breadcrumb.map((item, index) => {
        const isLast = index === breadcrumb.length - 1;
        return (
          <Fragment key={`${item.label}-${index}`}>
            <li className="ui-page-header__crumb">
              {item.to && !isLast ? (
                <Link to={item.to} className="ui-page-header__crumb-link">
                  {item.label}
                </Link>
              ) : (
                <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
              )}
            </li>
            {!isLast && (
              <li className="ui-page-header__crumb-separator" aria-hidden="true">
                <ChevronRight />
              </li>
            )}
          </Fragment>
        );
      })}
    </ol>
  );
}

const PageHeader = forwardRef(function PageHeader(
  { title, subtitle, actions, breadcrumb, className, ...rest },
  ref
) {
  return (
    <div {...rest} ref={ref} className={cx('ui-page-header', className)}>
      {breadcrumb && (
        <nav aria-label="Breadcrumb" className="ui-page-header__breadcrumb">
          {renderBreadcrumb(breadcrumb)}
        </nav>
      )}
      <div className="ui-page-header__row">
        <div className="ui-page-header__text">
          {title && <h1 className="ui-page-header__title">{title}</h1>}
          {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="ui-page-header__actions">{actions}</div>}
      </div>
    </div>
  );
});

export default PageHeader;
